/* Native sticky scene: scrolling advances the ruler and the five Figma graph states. */
(function () {
  'use strict';
  if (window.mnlGrowthLoaded) return;
  window.mnlGrowthLoaded = true;
  function init(root) {
    root.querySelectorAll('[data-mnl-growth]').forEach(function (section) {
      if (section.__growth) return;
      section.__growth = true;
      var journey = section.querySelector('.mnl-ins-reads__journey');
      var geometry = JSON.parse(section.querySelector('[data-growth-geometry]').textContent);
      var paths = section.querySelectorAll('[data-growth-path]');
      var shape = section.querySelector('[data-growth-shape]');
      var mobilePaths = section.querySelectorAll('[data-growth-mobile-path]');
      var card = section.querySelector('.mnl-ins-reads__card');
      var mobileLayout = false, cardWidth = 342, cardHeight = 476.234;
      var frost = section.querySelector('[data-growth-frost]');
      var mobileFrost = section.querySelector('[data-growth-mobile-frost]');
      var gradients = section.querySelectorAll('[data-growth-gradient]');
      var numberPattern = /[-+]?(?:\d*\.)?\d+(?:e[-+]?\d+)?/gi;
      function attr(node, key, value) { if (node.getAttribute(key) !== value) node.setAttribute(key, value); }
      function mix(a, b, t) { return a + (b - a) * t; }
      function morph(value) {
        var lower = Math.floor(value), t = value - lower;
        var a = geometry.states[lower], b = geometry.states[Math.min(lower + 1, geometry.states.length - 1)];
        if (!mobileLayout) paths.forEach(function (path, i) {
          var cursor = 0;
          attr(path, 'd', geometry.patterns[i].replace(/\{\}/g, function () {
            var n = cursor++;
            return mix(a.paths[i][n], b.paths[i][n], t).toFixed(3);
          }));
        });
        if (!mobileLayout) attr(shape, 'transform', 'translate(' + mix(a.offset[0], b.offset[0], t).toFixed(3) + ' ' + mix(a.offset[1], b.offset[1], t).toFixed(3) + ')');
        // Mobile Figma curves use independent horizontal/vertical scales, not
        // a crop of the desktop graph. Retain the same five scroll-driven states.
        function mobileCoordinate(n, axis, pathIndex) {
          var offset = mix(a.offset[axis], b.offset[axis], t) - geometry.states[1].offset[axis];
          var lowerLineOffset = 12.385 + 22.691 * Math.max(0, (value - 1) / 3);
          return axis ? (n + offset) * .756285 + (pathIndex === 0 ? 35.076 : lowerLineOffset) : (n + offset) * .273401 + 107.449;
        }
        if (mobileLayout) mobilePaths.forEach(function (path) {
          var i = Number(path.dataset.growthMobilePath), cursor = 0;
          var mobilePath = geometry.patterns[i].replace(/\{\}/g, function () {
            var n = cursor++;
            return mobileCoordinate(mix(a.paths[i][n], b.paths[i][n], t), n % 2, i).toFixed(3);
          });
          // Stroke only the upper curve, never the closing sides of the fill.
          if (path.hasAttribute('stroke')) mobilePath = mobilePath.replace(/L[^L]+L[^L]+L([^C]+)(C.*)Z$/, 'M$1$2');
          attr(path, 'd', mobilePath);
        });
        if (!mobileLayout) {
        // The frosted region shares the curve's geometry, including during a morph.
        var point = 0;
        var frostPath = geometry.patterns[0].replace(/\{\}/g, function () {
          var n = point++, axis = n % 2;
          if (mobileLayout) {
            var position = mobileCoordinate(mix(a.paths[0][n], b.paths[0][n], t), axis, 0);
            return ((position + (axis ? 94.34 : cardWidth / 2 - 385.99)) / (axis ? cardHeight : cardWidth)).toFixed(7);
          }
          return ((mix(a.paths[0][n], b.paths[0][n], t) + mix(a.offset[axis], b.offset[axis], t)) / (axis ? 685.093 : 1360)).toFixed(7);
        });
        attr(frost, 'd', frostPath);
        if (mobileLayout) attr(mobileFrost, 'd', frostPath);
        gradients.forEach(function (gradient, i) {
          Object.keys(a.gradients[i]).forEach(function (key) {
            var end = b.gradients[i][key].match(numberPattern), cursor = 0;
            attr(gradient, key, a.gradients[i][key].replace(numberPattern, function (n) {
              return mix(Number(n), Number(end[cursor++]), t).toFixed(4);
            }));
          });
        });
        }
      }
      var copies = Array.from(section.querySelectorAll('[data-growth-copy]'));
      // Split text nodes only: preserve authored line breaks and natural spaces.
      var copyWords = copies.map(function (copy) {
        var heading = copy.querySelector('h3');
        Array.from(heading.childNodes).forEach(function (node) {
          if (node.nodeType !== 3) return;
          var fragment = document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) fragment.appendChild(document.createTextNode(part));
            else {
              var word = document.createElement('span');
              word.className = 'mnl-ins-reads__word';
              word.textContent = part;
              fragment.appendChild(word);
            }
          });
          node.replaceWith(fragment);
        });
        return Array.from(heading.querySelectorAll('.mnl-ins-reads__word'));
      });
      section.classList.add('has-growth-stagger');
      var months = Array.from(section.querySelectorAll('[data-growth-months]'));
      var ticks = section.querySelectorAll('.mnl-ins-reads__ticks');
      var motion = matchMedia('(prefers-reduced-motion: reduce)');
      var zoom = 1, top = 0, runway = 2400, frame = 0, current = 0, target = 0, active = -1;
      var clamp = function (n, a, b) { return Math.max(a, Math.min(b, n)); };
      var measuredWidth = 0;
      function measure() {
        var width = document.documentElement.clientWidth;
        if (width <= 767 && width === measuredWidth) return;
        measuredWidth = width;
        zoom = section.getBoundingClientRect().width / section.offsetWidth || 1;
        var mobile = window.innerWidth <= 767;
        mobileLayout = mobile;
        cardWidth = card.clientWidth;
        cardHeight = card.clientHeight;
        // Pin after the heading exits, with the month ruler 20px below the viewport top.
        top = mobile ? -143.34 : Math.min(0, innerHeight / zoom - 862);
        // About one gentle screenful per month; leave time to read the first and last scene.
        runway = mobile ? Math.max(2800, innerHeight * 4) : Math.max(1600, innerHeight / zoom * 3.2);
        journey.style.setProperty('--growth-top', top + 'px');
        journey.style.setProperty('--growth-runway', runway + 'px');
        copyWords.forEach(function (words) {
          // Measure actual wrapped lines, including mobile layouts.
          var lines = [];
          words.forEach(function (word) {
            var line = lines.find(function (row) { return Math.abs(row.top - word.offsetTop) < 2; });
            if (!line) { line = { top: word.offsetTop, words: [] }; lines.push(line); }
            line.words.push(word);
          });
          lines.sort(function (a, b) { return b.top - a.top; });
          lines.forEach(function (line, row) {
            line.words.forEach(function (word, column) {
              word.__growthExit = { row: row, rows: lines.length, column: column, count: line.words.length };
            });
          });
          words.forEach(function (word) {
            var heading = word.parentElement;
            word.style.backgroundSize = heading.offsetWidth + 'px ' + heading.offsetHeight + 'px';
            word.style.backgroundPosition = -word.offsetLeft + 'px ' + -word.offsetTop + 'px';
          });
        });
        painted = -1;
        request();
      }
      function position() {
        var travel = top - journey.getBoundingClientRect().top / zoom;
        return clamp((travel / runway * 4.5) - .25, 0, geometry.states.length - 1);
      }
      var painted = -1;
      function render(value) {
        if (Math.abs(value - painted) < .0005) return;
        painted = value;
        morph(value);
        copies.forEach(function (copy, i) {
          var scene = i % geometry.states.length;
          var distance = value - scene;
          var visible = motion.matches ? Math.round(value) === scene : distance > -.48 && distance < .48;
          copy.style.visibility = visible ? 'visible' : 'hidden';
          if (!visible) return;
          var entering = distance < 0;
          // Each boundary has an exit, a clear gap, then an entrance.
          // Never display the outgoing and incoming headlines together.
          var progress = clamp((entering ? distance + .48 : distance - .2) / .28, 0, 1);
          copy.querySelector('.mnl-ins-reads__tag').style.opacity = String(motion.matches ? 1 : entering ? progress : 1 - progress);
          var words = copyWords[i];
          words.forEach(function (word, n) {
            var order = word.__growthExit;
            var local = entering ? progress : clamp(progress * order.rows - order.row, 0, 1);
            var rank = entering ? n : order.column;
            var count = entering ? words.length : order.count;
            var phase = clamp((local - rank / Math.max(1, count - 1) * .45) / .55, 0, 1);
            var amount = motion.matches ? 1 : entering ? phase : 1 - phase;
            word.style.opacity = amount.toFixed(4);
            word.style.transform = 'translate3d(0,' + ((1 - amount) * 100).toFixed(3) + '%,0)';
          });
        });
        var index = clamp(Math.round(value), 0, geometry.states.length - 1);
        if (index !== active) {
          active = index;

          section.dataset.growthScene = String(index + 1);
          [copies, months].forEach(function (items) {
            items.forEach(function (item, i) {
              item.classList.toggle('is-active', i % geometry.states.length === index);
              item.setAttribute('aria-hidden', String(i % geometry.states.length !== index));
            });
          });
        }
        // Labels stay fixed; only the continuous tick strips move left.
        var offset = motion.matches ? 0 : -(value * 654.5 % (8.62143 * 60));
        ticks.forEach(function (strip) { strip.style.transform = 'translate3d(' + offset.toFixed(3) + 'px,0,0)'; });
      }
      function update() {
        frame = 0;
        target = position();
        if (motion.matches) target = Math.round(target);
        current = target; // Scrub exactly: stopping scroll freezes every word immediately.
        render(current);
      }
      function request() { if (!frame) frame = requestAnimationFrame(update); }
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', measure);
      motion.addEventListener('change', request);
      measure();
      current = position();
      render(current);
      document.fonts.ready.then(function () {
        if (!section.isConnected) return;
        measuredWidth = 0;
        measure();
      });
      (section.closest('.shopify-section') || section).addEventListener('shopify:section:unload', function () {
        cancelAnimationFrame(frame);
        window.removeEventListener('scroll', request);
        window.removeEventListener('resize', measure);
        motion.removeEventListener('change', request);
        delete section.__growth;
      }, { once: true });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
